import { createFileRoute } from '@tanstack/react-router';
import { PendingOBSApi } from '../../../../../components/PendingOBSApi';
import { ensureOBSPresence } from '../../../../../utils/ensureOBSPresence';
import { promisefy } from '../../../../../utils/promisefy';
import { getEnabledSources } from '../../-sceneDropdownMenu/getEnabledSources';

export const Route = createFileRoute('/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass')({
  component: () => null,
  pendingComponent: PendingOBSApi,
  loader: async ({ params: { sourceClass } }) => {
    await ensureOBSPresence();

    const existingSourcesOfType = await promisefy(window.host.getAllExistingVideoInputSources)();
    const enabledSources = await getEnabledSources();
    const existingSourcesOfClass = existingSourcesOfType.filter((source) => source.class === sourceClass);

    return { existingSourcesOfClass, enabledSources };
  },
});
